// removed by extract-text-webpack-plugin
module.exports = {"leadsList":"_3vKRS5rKtXt08Ay8ft1EMN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LeadsList/LeadsList.scss
// module id = 1624
// module chunks = 0